/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    angular
        .module('enervee')
        .directive('loginModal', loginModalDirective);

    function loginModalDirective() {
        return {
            restrict: 'E',
            controller: [
                '$scope',
                '$state',
                'AccountAuthService',
                'AnalyticsService',
                'ForgotPasswordService',
                'IndexService',
                'UtilService',
                'SignupService',
                function loginModalController(
                    $scope,
                    $state,
                    AccountAuthService,
                    AnalyticsService,
                    ForgotPasswordService,
                    IndexService,
                    UtilService,
                    SignupService
                ) {
                    $scope.loginMessage = UtilService.getSiteSetting('login_message');
                    $scope.forgotUserEmail = null;
                    $scope.switchModal = IndexService.switchModal;
                    $scope.resetFormField = IndexService.resetFormField;
                    $scope.userEmail = null;
                    const state = $state;

                    SignupService.signInPasswordModalOpenedCallBack = function (trigger) {
                        $scope.dataTrigger = trigger;
                    };

                    /**
                     * Sets the user email from other application feature directives.
                     */
                    $scope.$on('login-credentials-set', function(obj, email) {
                        $scope.userEmail = email;
                    });


                    /**
                     *  Submits the password for logging in an existing user.
                     *
                     * @param user ng-model for form fields
                     * @param currentModal - used to close if login was successful.
                     */
                    $scope.submitPasswordForm = function(user, currentModal) {
                        let product = null;
                        // add product for meta event
                        if (state.$current.name === "product.base") {
                            product = state.$current.parent.data.productDetailData;
                        }

                        AccountAuthService.logIn($scope.userEmail, user.password).then(function() {
                            var _is_authenticated = AccountAuthService.isAuthenticated();

                            if (_is_authenticated === true) {
                                user.password = null; // clear password after successful login
                                AnalyticsService.trackUser();
                                AnalyticsService.reportEvent('Signed In', {
                                    email: $scope.userEmail,
                                    location: 'modal',
                                    type: $scope.dataTrigger,
                                    status: 'full user'
                                }, product);

                                IndexService.closeModal(currentModal);
                            } else {
                                $scope.enterPasswordForm.password.$error.invalid = true;
                            }
                        });

                    };

                    /**
                     * Function to trigger Password Reset Process
                     *
                     * @param currentModal
                     */
                    $scope.forgotPasswordEmail = function(currentModal) {
                        ForgotPasswordService.resetPassword($scope.userEmail).then(function() {

                            var _resetPasswordSent = ForgotPasswordService.resetPasswordSent();

                            if (_resetPasswordSent.success === true) {
                                $scope.forgotUserEmail = $scope.userEmail;
                                IndexService.switchModal(currentModal, '#modal-sent-email');
                            } else {
                                // TODO - Display "error sending password reset". Need modal.
                            }
                        });
                    };
                }
            ],
            template: require('@app/shared/modals/login/login.html'),
        };
    }
})(angular);
